import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';

import { BestOfEuropeBanner } from './BestOfEurope';
import { NBABanner } from './Nba';

export const Banner = () => {
  const {
    flags: { useBestOfEurope = false },
  } = useFeatureFlags();

  if (useBestOfEurope) {
    return <BestOfEuropeBanner />;
  }
  return <NBABanner />;
};
